import { useEffect, useState } from "react";
import { Button, Modal, Radio, notification } from "antd";
import type { RadioChangeEvent } from "antd/lib/radio";
import { useFreire } from "../../utils/freireContext";
import {
  SHARE_STATION_TITLE,
  CLOSE,
  COPY_SHARE_LINK,
  ALL_RIGHT,
  SHARE_LINK_COPIED,
  SHARE_STATION_NO_APP,
} from "../../pages/Stations/locales";
import { useWhitelabels } from "../../components/WhitelabelThemesProvider";
import type { Whitelabel } from "../../components/WhitelabelThemesProvider";
import "./index.css"
import copy from "copy-to-clipboard";

type ShareStationProps = {
  visible: boolean;
  stationID: string;
  onClose: () => void;
};

const ShareStation = ({ visible, stationID, onClose }: ShareStationProps) => {
  const { freire } = useFreire();
  const { allWhitelabels, getWhitelabelByAlias } = useWhitelabels();

  const [appConfig, setAppConfig] = useState<Whitelabel>();

  const onChange = (e: RadioChangeEvent) => {
    setAppConfig(e.target.value);
  }

  const onSubmit = async () => {
    if (!appConfig) return;
    const whitelabel = getWhitelabelByAlias(appConfig.alias);
    if (!whitelabel?.linkBranchIo) return;

    copy(`${whitelabel.linkBranchIo}/estacao/${stationID}`);

    notification.success({
      message: freire(ALL_RIGHT),
      description: freire(SHARE_LINK_COPIED),
    });

    onClose();
  }

  useEffect(() => {
    setAppConfig(undefined);
  }, [visible]);

  const noLinksConfigured = Object.values(allWhitelabels).every((wl) => !wl.linkBranchIo);

  return (
    <Modal
      title={freire(SHARE_STATION_TITLE)}
      visible={visible}
      width="30%"
      destroyOnClose
      centered
      onCancel={() => onClose()}
      footer={[
        <Button key="cancel" onClick={() => onClose()}>
          {freire(CLOSE)}
        </Button>,
        <Button
          key="submit"
          type="primary"
          disabled={!appConfig}
          onClick={() => onSubmit()}
        >
          {freire(COPY_SHARE_LINK)}
        </Button>,
      ]}
    >
      {noLinksConfigured ? (
        <p className="ShareStationEmptyMessage">{freire(SHARE_STATION_NO_APP)}</p>
      ) : (
        <Radio.Group
          className="ShareStationRadioContainer"
          value={appConfig}
          onChange={onChange}
        >
          {Object.values(allWhitelabels).map((whitelabel: Whitelabel) => {
            if (!whitelabel.linkBranchIo) return null;
            return (
              <Radio key={whitelabel.alias} value={whitelabel}>
                {whitelabel.name}
              </Radio>
            );
          })}
        </Radio.Group>
      )}
    </Modal>
  );
};

export default ShareStation;
